import React, { useEffect, useState } from "react";
import {
  Modal,
  Select,
  Form,
  Row,
  Col,
  Typography,
  message,
  Table,
  Button,
  Input,
} from "antd";
import { platformApi } from "../../../../../api";
import moment from "moment";

const { Text, Title } = Typography;

const TrackSpareOrderModal = ({ open, close, jobId }) => {
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getData();
  }, [jobId]);

  const getData = () => {
    try {
      platformApi
        .get(`/api/customerSpareOrderRouter/jobcard/${jobId}`)
        .then((res) => {
          console.log(res.data.data.parts);

          setDataSource(res.data.data.parts);
        });
    } catch (err) {
      console.error("error getting spare order status:", err);
    }
  };

  // Determine discount column title based on discountLevel
  const discountTitle =
    dataSource[0]?.discountLevel === "percent"
      ? "Discount (%)"
      : "Discount (₹)";

  return (
    <Modal
      width="80%"
      title={<Title level={4}>Spare Order Status</Title>}
      visible={open}
      onCancel={close}
      onOk={close}
    >
      <Table
        dataSource={dataSource}
        rowKey={(record) => record.orderId + record.part}
        pagination={false}
        columns={[
          {
            title: "Order Number",
            dataIndex: "orderNumber",
            key: "orderNumber",
          },
          {
            title: "Order Date",
            dataIndex: "orderDate",
            key: "orderDate",
            render: (date) => (date ? moment(date).format("DD/MM/YY") : "-"),
          },
          {
            title: "Part Number",
            dataIndex: "partNumber",
            key: "partNumber",
          },
          {
            title: "Part Name",
            dataIndex: "partName",
            key: "partName",
          },
          {
            title: "Bin Number",
            dataIndex: "binNum",
            key: "binNum",
            render: (value) => `${value || "-"}`,
          },
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
          },
          {
            title: "Unit Rate (₹)",
            dataIndex: "unitRate",
            key: "unitRate",
            render: (value) => `${value}`,
          },
          {
            title: "Total (₹)",
            dataIndex: "grossAmount",
            key: "grossAmount",
            render: (value) => `${value}`,
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
              <span
                style={{
                  color:
                    status === "PENDING"
                      ? "red"
                      : status === "ORDERED"
                      ? "blue"
                      : "green",
                }}
              >
                {status}
              </span>
            ),
          },
        ]}
      />

    <Row style={{ marginTop: 16, marginBottom: 24 }}>
      <Col flex="auto" />
      <Col>
        <div style={{ position:"absolute", alignItems: "center",right:0}}>
          <b style={{ marginRight: 8 }}>Total:</b>
          <span style={{ 
            // width: 120, 
            display: "inline-block", 
            textAlign: "center", 
            fontWeight: "bold" 
          }}>
            {
              dataSource.reduce(
                (sum, item) => sum + (Number(item.grossAmount) || 0),
                0
              )
            }
          </span>
        </div>
      </Col>
    </Row>

    </Modal>
  );
};

export default TrackSpareOrderModal;
